import { render, staticRenderFns } from "./CheckoutFailureView.vue?vue&type=template&id=f73f93ea"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {UiIconsClose: require('/home/node/app/components/ui/icons/close.vue').default,UiButtonComponent: require('/home/node/app/components/ui/buttonComponent.vue').default})
